module.exports = __webpack_public_path__ + "img/circle.2215003b.png";